import { NavigateFunction } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

/**
 * Handles the case where a user's membership has been revoked.
 * Shows an informative message, logs out the user, and redirects to auth page.
 *
 * This typically happens when:
 * - An admin deletes the user's membership while they're logged in
 * - Database inconsistencies result in missing membership
 *
 * @param navigate - React Router navigation function
 * @param toast - Toast notification function
 */
export const handleMembershipRevoked = async (
  navigate: NavigateFunction,
  toast: (options: {
    title: string;
    description: string;
    variant?: "default" | "destructive";
    duration?: number;
  }) => void
) => {
  toast({
    title: "Accès révoqué",
    description: "Votre accès à cette organisation a été révoqué. Veuillez contacter votre administrateur pour plus d'informations.",
    variant: "destructive",
    duration: 8000, // Longer duration so user can read
  });

  // Sign out the user to clean up the session
  try {
    await supabase.auth.signOut({ scope: 'local' });
  } catch (error) {
    console.warn('SignOut failed, cleaning up manually:', error);
  }
  // Nettoyer manuellement les clés Supabase du localStorage (au cas où signOut échoue)
  const keysToRemove = Object.keys(localStorage).filter(key =>
    key.startsWith('sb-') || key.includes('supabase')
  );
  keysToRemove.forEach(key => localStorage.removeItem(key));

  // Forcer un rechargement complet pour réinitialiser l'état React
  window.location.href = "/auth";
};
